export const GET_STATS_INFO = 'stats/info/get';
export const GET_STATS_INFO_SUCCESS = 'stats/info/get/success';

export const GET_STATS = 'stats/get';
export const GET_STATS_SUCCESS = 'stats/get/success';
